import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Column, Row } from '@hero/atoms';
import { PageLayout } from '@hero/components/layouts';
import { useIsAutomationEnabled } from '@hero/hooks';
import { WelcomeCard } from '@hero/molecules';
import { RecentAutomationCards, RecentRecognitionsTable, RocketModal } from '@hero/organisms';
import { useUpdateUser } from '@hero/services/organization-service/hooks';
import { useOnboardingStore } from '@hero/store/hooks';

import { translationMapping } from './translationMapping';

function DefaultDashboard() {
  const { t } = useTranslation();

  const { firstTour, updateFirstTour, updateTourProgress } = useOnboardingStore();
  const isAutomationEnabled = useIsAutomationEnabled();
  const { mutate: mutateUpdateUser } = useUpdateUser({
    onSuccess: () => {
      updateTourProgress({
        featureType: 'recognition',
        infoCardsActive: true
      });
      setIsOnboardingCardShown(true);
      updateFirstTour(true);
    }
  });

  const [showingRocketModal, setShowingRocketModal] = useState(null);
  const [isOnboardingCardShown, setIsOnboardingCardShown] = useState(false);

  const [firstRocketModal, secondRocketModal] = translationMapping.existingUser;

  const handleUpdateUser = () => {
    mutateUpdateUser({
      status: {
        hasWalkedThrough: {
          isCompletedFirstTour: true
        }
      }
    });
  };

  return (
    <PageLayout
      header={{
        title: t('dashboard')
      }}
    >
      <Row gap="16px">
        <WelcomeCard
          isOnboardingCardShown={isOnboardingCardShown}
          setIsOnboardingCardShown={setIsOnboardingCardShown}
        />
        <Column flex={3} style={{ maxWidth: '100%' }}>
          <RecentRecognitionsTable />
          {isAutomationEnabled && <RecentAutomationCards />}
        </Column>
      </Row>

      {!firstTour && (
        <>
          {showingRocketModal === 1 && (
            <RocketModal
              title={firstRocketModal.title}
              desc={firstRocketModal.desc}
              firstButtonText="GUIDED TOUR"
              firstButtonClick={() => {
                setShowingRocketModal(2);
              }}
            />
          )}
          {showingRocketModal === 2 && (
            <RocketModal
              title={secondRocketModal.title}
              desc={secondRocketModal.desc}
              firstButtonText="START TOUR"
              firstButtonClick={handleUpdateUser}
            />
          )}
        </>
      )}
    </PageLayout>
  );
}

export { DefaultDashboard };
